import React, { useContext, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserContext, ReportsDownloadUpdate } from "./MainLayout";
import { checkActiveTab, isFeatureEnabled } from "../utils/utils";
import { sideMenuAccessForUser } from "../utils/constants/userConstants";
import "./MainLayout.scss";
import { useTranslation } from "react-i18next";
import { isServiceToolShow } from "../utils/constants/serviceToolConstant";

const Sidebar = () => {
  const { userData, loggedInUserRole, featureEnabledStatus, appTheme } =
    useContext(UserContext);
  const { reportUpdateStatus } = useContext(ReportsDownloadUpdate);
  const location = useLocation();
  const { t } = useTranslation("sidebar");

  const isAllowed = useCallback(
    (menu) => {
      return sideMenuAccessForUser[loggedInUserRole].indexOf(menu) !== -1;
    },
    [loggedInUserRole]
  );

  return (
    <nav className="sidebarWrapper">
      <Link to="/" id="logo" className="logo">
        <img
          alt="logo"
          src={require("../assets/images/chorus-white-logo.png")}
          className="img-fluid"
        />
      </Link>
      {Object.keys(userData).length ? (
        <ul className="sidebarList">
          {isAllowed("dashboard") && (
            <li>
              <Link
                to=""
                id="dashboard"
                className={checkActiveTab("/") ? "active" : " "}
              >
                <img
                  alt="dashboard"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/dashboard.png")
                      : require("../assets/images/icons/dark_dashboard.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("dashboard")}</span>
              </Link>
            </li>
          )}
          {isAllowed("deviceView") && (
            <li>
              <Link
                id="deviceview"
                to="/device-view"
                className={
                  checkActiveTab("/device-view", true) ? "active" : " "
                }
              >
                <img
                  alt="devices"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/devices.png")
                      : require("../assets/images/icons/dark_devices.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("device")}</span>
              </Link>
            </li>
          )}
          {isAllowed("reports") && (
            <li>
              <Link
                to="/reports"
                id="reports"
                className={
                  location.pathname.includes("/reports") ? "active" : " "
                }
              >
                {reportUpdateStatus?.length ? (
                  <img
                    alt="reports"
                    src={
                      appTheme === "light"
                        ? require("../assets/images/icons/statisticsWithStatus.png")
                        : require("../assets/images/icons/dark_statisticsWithStatus.png")
                    }
                    className="img-fluid"
                  />
                ) : (
                  <img
                    alt="reports"
                    src={
                      appTheme === "light"
                        ? require("../assets/images/icons/statistics.png")
                        : require("../assets/images/icons/dark_statistics.png")
                    }
                    className="img-fluid"
                  />
                )}
                <span className="sidebarIconLabel">{t("reports")}</span>
              </Link>
            </li>
          )}
          {isAllowed("location") && (
            <li>
              <Link
                to="/location-dashboard"
                id="location"
                className={
                  checkActiveTab("/location-dashboard") ? "active" : " "
                }
              >
                <img
                  alt="locations"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/pin.png")
                      : require("../assets/images/icons/dark_pin.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("locations")}</span>
              </Link>
            </li>
          )}
          {isAllowed("schedules") && featureEnabledStatus.scheduler && (
            <li>
              <Link
                to="/schedules"
                id="schedules-menu"
                className={checkActiveTab("/schedules") ? "active" : " "}
              >
                <img
                  alt="schedules"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/schedules.png")
                      : require("../assets/images/icons/dark_schedules.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("Scheduler")}</span>
              </Link>
            </li>
          )}
          {isAllowed("sites") && (
            <li>
              <Link
                id="sites"
                to="/sites-dashboard"
                className={checkActiveTab("/sites-dashboard") ? "active" : " "}
              >
                <img
                  alt="sites"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/sites.png")
                      : require("../assets/images/icons/dark_sites.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("sites")}</span>
              </Link>
            </li>
          )}

          {isAllowed("users") && (
            <li>
              <Link
                id="user_management"
                to="/user-management"
                className={checkActiveTab("/user-management") ? "active" : " "}
              >
                <img
                  alt="users"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/users.png")
                      : require("../assets/images/icons/dark_users.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("users")}</span>
              </Link>
            </li>
          )}

          {isAllowed("ota") && (
            <li title="Not Supported">
              <Link
                id="ota-management"
                className={
                  checkActiveTab("/ota-management")
                    ? "active not-allowed"
                    : "not-allowed"
                }
              >
                <img
                  alt="ota"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/ota.png")
                      : require("../assets/images/icons/dark_ota.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("ota")}</span>
              </Link>
            </li>
          )}

          {isServiceToolShow() && isAllowed("serviceTool") && (
            <li title="Not Supported">
              <Link
                id="service-tool"
                to={"/service-tool"}
                className={checkActiveTab("/service-tool") ? "active" : ""}
              >
                <img
                  alt="service-tool"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/service-tool.png")
                      : require("../assets/images/icons/service-tool.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("service")}</span>
              </Link>
            </li>
          )}

          {isAllowed("settings") && (
            <li title="Not Supported">
              <Link
                id="settings"
                className={
                  checkActiveTab("/settings")
                    ? "active not-allowed"
                    : "not-allowed"
                }
              >
                <img
                  alt="settings"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/settings.png")
                      : require("../assets/images/icons/dark_settings.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("settings")}</span>
              </Link>
            </li>
          )}

          {isAllowed("help") && (
            <li>
              <Link
                id="helpsupport"
                to="/help"
                className={checkActiveTab("/help") ? "active" : " "}
              >
                <img
                  alt="help"
                  src={
                    appTheme === "light"
                      ? require("../assets/images/icons/help.png")
                      : require("../assets/images/icons/dark_help.png")
                  }
                  className="img-fluid"
                />
                <span className="sidebarIconLabel">{t("help")}</span>
              </Link>
            </li>
          )}
        </ul>
      ) : (
        <></>
      )}
    </nav>
  );
};

export default Sidebar;
